var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAward(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M121 0v95c0 87.328 56.976 161.57 135 188.838C334.024 256.57 391 182.328 391 95V0H121z",
    fill: "var(--primary-color)",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.539 195.818C65.873 155.375 34.604 95.982 30.469 30H91V0H0v15c0 30.516 5.146 60.438 15.296 88.934 9.81 27.541 24.061 53.146 42.357 76.104 27.078 33.978 62.272 60.793 101.734 78.017a231.545 231.545 0 0 1-44.848-62.237zM421 0v30h60.531c-4.135 65.982-35.404 125.375-84.07 165.818a231.511 231.511 0 0 1-44.849 62.237c39.462-17.224 74.656-44.039 101.734-78.017 18.297-22.958 32.548-48.563 42.357-76.104C506.854 75.438 512 45.516 512 15V0h-91zM371 482V362h-85v-57.94a233.343 233.343 0 0 1-20.103 8.099L256 315.618l-9.897-3.459A233.343 233.343 0 0 1 226 304.06V362h-85v120h-30v30h290v-30h-30zm-70-40h-90v-30h90v30z",
    fill: "var(--primary-color)",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAward);
export default __webpack_public_path__ + "static/media/award.7baa54eb99d8a300f4a40cf26e617933.svg";
export { ForwardRef as ReactComponent };